import { render } from "./TextHint.vue?vue&type=template&id=482c190c"
import script from "./TextHint.vue?vue&type=script&lang=ts"
export * from "./TextHint.vue?vue&type=script&lang=ts"

import "./TextHint.vue?vue&type=style&index=0&id=482c190c&lang=scss"
script.render = render

export default script